import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {ConfigServiceProvider} from "../../../services/config/config.service.provider";
import {ActivatedRoute, Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {CrystalClearFrontUrl} from "../../../shared/pages/crystal-clear-front-url";
import {PageDescription} from "../../../shared/pages/page-description";
import {MenuItem, MessageService} from "primeng/api";
import {User} from "../../../model/security/user";
import {UserInfoStorageService} from "../../../services/auth/user-info-storage.service";
import {HeaderActionService} from "../../../services/header-action.service";
import {ToastService} from "../../../services/toast-service";
import {Locale} from "../../../utils/locale";
import {RoutingData} from "../../../routing/routing-data";
import {CrystalClearFrontUrlCustomer} from "../../../shared/pages/crystal-clear-front-url-customer";
import {CrystalClearFrontUrlExchange} from "../../../shared/pages/crystal-clear-front-url-exchange";
import {CrystalClearFrontUrlMapping} from "../../../shared/pages/crystal-clear-front-url-mapping";
import {CrystalClearFrontUrlETicket} from "../../../shared/pages/crystal-clear-front-url-eticket";
import {AppConfigService} from "../../../services/app-config.service";


@Component({
  selector: 'cc-dock',
  templateUrl: './dock-layout.component.html',
  styleUrls: ['./dock-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ConfigServiceProvider, MessageService
  ]
})
export class DockComponent implements OnInit {

  router: Router;
  userInfo: User;
  userFormVisible: boolean = false;
  isAuthenticated: boolean;
  dockItems: MenuItem[];
  CRMMenuItems: MenuItem[];


  constructor(private authService: UserInfoStorageService,
              router: Router,
              private headerActionService: HeaderActionService,
              private route: ActivatedRoute,
              private toastService: ToastService,
              private translateService: TranslateService,
              private appConfigService: AppConfigService) {
    this.router = router;
    translateService.addLangs([Locale.LANGS.EN_GB.id]);
    translateService.setDefaultLang(Locale.LANGS.EN_GB.id);
    translateService.use(Locale.LANGS.EN_GB.id);

  }

  logInOut() {
    if (this.isAuthenticated) {
      this.authService.logout();
      this.router.navigate(['/' + CrystalClearFrontUrl.LOGIN.path]);
    } else {
      const extras = [];
      extras[RoutingData.Extras.REDIRECT_TO] = this.router.url;
      this.router.navigate(['/' + CrystalClearFrontUrl.LOGIN.path], {queryParams: extras});
    }
  }

  getUserInformation() {
    if (this.authService.isAuthenticated) {
      this.authService.refreshConnectedUserCacheInfo().subscribe(userInfo => {
        this.userInfo = userInfo ? Object.assign(new User(), userInfo) : null;
      if (!this.userInfo) {
        this.logInOut();
      }
      this.initMenuItems();
      });
    } else {
      this.logInOut();
    }
  }

  private initMenuItems() {

    if (this.userInfo) {
      this.dockItems = [];
      this.addDockButton(CrystalClearFrontUrl.TRADES_ORDERS);
      if (this.appConfigService.eticketEnabled) {
        this.addDockButton(CrystalClearFrontUrlETicket.NEW_ETICKET);
        this.addDockButton(CrystalClearFrontUrlETicket.LIST_ETICKET);
      }

      let recapPage: PageDescription = CrystalClearFrontUrl.ARCHIVE_RECAP_PROFILE;
      if (!PageDescription.isVisible(this.userInfo.roles, recapPage))
        recapPage = CrystalClearFrontUrl.ARCHIVE_RECAP_FORM;
      recapPage = {
        label: 'page_title.recap.header',
        roles: recapPage.roles,
        path: recapPage.path,
        icon: recapPage.icon
      };
      let reportPage: PageDescription = CrystalClearFrontUrl.ARCHIVE_REPORT_FORM;
      if (!PageDescription.isVisible(this.userInfo.roles, reportPage))
        reportPage = CrystalClearFrontUrl.ARCHIVE_REPORT_PROFILE;
      reportPage = {
        label: 'page_title.archive.header',
        roles: reportPage.roles,
        path: reportPage.path,
        icon: reportPage.icon
      };
      let billingPage: PageDescription = CrystalClearFrontUrl.ARCHIVE_BILLING_LIST;
      if (!PageDescription.isVisible(this.userInfo.roles, billingPage))
        billingPage = CrystalClearFrontUrl.ARCHIVE_BILLING_LIST;
      billingPage = {
        label: 'page_title.billing.header',
        roles: billingPage.roles,
        path: billingPage.path,
        icon: billingPage.icon
      };
      this.addDockButton(recapPage);
      this.addDockButton(reportPage);
      if (this.appConfigService.billingEnabled) {
        this.addDockButton(billingPage);
      }
      this.addDockButton(CrystalClearFrontUrlCustomer.CUSTOMER);
      this.addDockButton(CrystalClearFrontUrlExchange.EXCHANGE);
      this.addDockButton(CrystalClearFrontUrlMapping.MAPPING);

      // this.archiveMenuItems= [
      //   this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_FORM, false),
      //   this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_REPORT_PROFILE, false),
      //   this.toMenuItem(CrystalClearFrontUrl.ARCHIVE_RECAP_PROFILE, false)
      // ];

      // this.CRMMenuItems= [
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_OWNER, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_ACCEPTANCE_RULE, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_CUSTOMER_LIMITS, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_BROKER, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_BANK_ACCOUNT, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_ACCOUNT_TRADER, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_VAT_RATE, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_MONEY_OWNER, false),
      //     this.toMenuItem(CrystalClearFrontUrlCustomer.CUSTOMER_BROKERAGE_TABLE, false)
      //
      // ];
    }

  }

  private addDockButton(pageDesc: PageDescription): boolean {
    const userRoles = this.userInfo.roles;

    let isVisible: boolean = false;
    if (userRoles && pageDesc.roles) {
      userRoles.forEach(userRole => {
        if (pageDesc.roles.includes(userRole)) {
          isVisible = true;
        }
      });
    }
    if (isVisible) {
      this.dockItems.push({
        label: this.translateService.instant(pageDesc.label),
        tooltipOptions: {
          tooltipLabel: this.translateService.instant(pageDesc.label + '.tooltip')
          ,
          tooltipPosition: 'top',
          positionTop: -15,
          positionLeft: 15
        },
        icon: pageDesc.icon,
        command: () => {
          this.router.navigate([pageDesc.path]);
          // this.displayArchive = true;
        }
      });
      return true;
    }
    return false;
  }

  private toMenuItem(pDesc: PageDescription, iconOnly: boolean, subItems: MenuItem[] = []): MenuItem {
    return PageDescription.toMenuItem(pDesc, this.translateService,
      this.router, this.userInfo.roles, iconOnly, subItems);
  }

  ngOnInit(): void {


    this.authService.setLangFromStorage();

    this.getUserInformation();

    // this.langSelected = this.authService.lang;

    this.isAuthenticated = this.authService.isAuthenticated;

    // if (this.isAuthenticated) {
    //   this.authService.refreshConnectedUserCacheInfo();
    // }
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.initMenuItems();

    });

  }

}
